import React, { Dispatch, createContext, useState } from 'react';

const defaultSetShowDashboardOnMobileRoute: Dispatch<React.SetStateAction<
  boolean
>> = () => {};

const MobileDashboardContext = createContext({
  showDashboardOnMobileRoute: false,
  setShowDashboardOnMobileRoute: defaultSetShowDashboardOnMobileRoute
});

// This is too simple of a context provider to justify existing.
// Because of the way order summary currently works, I'm just leaving it.
// If we get to experiment with the deal drawer that should replace this,
// we can remove this stuff altogether. Until then I'm not overthinking it.
// For anyone curious, we keep the state here rather than the app level
// to prevent a re-render of the whole application shell when the state
// changes.
const MobileDashboardContextProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children
}) => {
  const [showDashboardOnMobileRoute, setShowDashboardOnMobileRoute] = useState(
    false
  );

  return (
    <MobileDashboardContext.Provider
      value={{ showDashboardOnMobileRoute, setShowDashboardOnMobileRoute }}
    >
      {children}
    </MobileDashboardContext.Provider>
  );
};

export default MobileDashboardContext;
export { MobileDashboardContextProvider };
